export const MAX_CAPACITY_FOR_TOUR = 50;
